import React, { useContext } from 'react'
import { AdminLogs, Logs } from '../../Common/Common'
import dayjs from 'dayjs'
import _ from 'lodash'
import LoginContext from '../LoginContext'

export default function LogsPanel ({ logs, date }) {
  const { user } = useContext(LoginContext)
  return (
    <>
      { user.roles.includes('admin') &&
        <AdminLogs
          entries={logs}
          title={dayjs(date).format('dddd DD MMMM YYYY')}
        />
      }
      { !user.roles.includes('admin') &&
        <Logs
          entries={logs.filter(log => log.type === 'log')}
          title={dayjs(date).format('dddd DD MMMM YYYY')}
        />
      }
    </>
  )
}
